export type VisitorDevice = "android" | "iphone" | "laptop"

export function getVisitorDevice(): VisitorDevice {
  if (typeof window === "undefined") return "laptop"

  const userAgent = window.navigator.userAgent
  const isIpadLikeMac =
    userAgent.includes("Macintosh") && window.navigator.maxTouchPoints > 1

  if (/Android/i.test(userAgent)) return "android"
  if (/iPhone|iPad|iPod/i.test(userAgent) || isIpadLikeMac) return "iphone"

  return "laptop"
}

export function isMobileStoreDevice(device: VisitorDevice): boolean {
  return device === "android" || device === "iphone"
}
